"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CloseButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _Icon = _interopRequireDefault(require("../Icon"));

var darkStyles = (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;&:hover{background-color:", ";[data-pka-anchor=\"button.icon\"]{color:", ";}}&:active{background-color:", ";transition:none;[data-pka-anchor=\"button.icon\"]{color:", ";transition:none;}}[data-pka-anchor=\"button.icon\"]{color:", ";transition:color 0.2s ease-out;}"], _stylers["default"].alpha(_tokens["default"].color.white, 0.2), _tokens["default"].color.white, _stylers["default"].alpha(_tokens["default"].color.white, 0.3), _tokens["default"].color.white, _tokens["default"].color.blackLighten50);
var CloseButton = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "CloseButtonstyles__CloseButton",
  componentId: "sc-17tyw7-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["[data-pka-anchor=\"button.icon\"]{color:", ";}", ""], _tokens["default"].textColor.icon, isDark ? darkStyles : "");
});
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.styles.js.map